export default __webpack_public_path__ + "static/media/scotiabank.ad36890e.webp";